exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".__form-extended .element[data-v-83e1763c]{margin-bottom:10px;text-align:center;display:block}.__form-extended .element .control[data-v-83e1763c]{width:100%;display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-83e1763c","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/form/Filter.vue
// module id = b724a8f88c1c544c65a9
// module chunks = 0